export const SHOW_ALERT_SUCCESS = "SHOW_ALERT_SUCCESS";
export const HIDE_ALERT_SUCCESS = "HIDE_ALERT_SUCCESS";
export const SHOW_MODAL_SUCCESS = "SHOW_MODAL_SUCCESS";
export const HIDE_MODAL_SUCCESS = "HIDE_MODAL_SUCCESS";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const CHECK_AUTH_SUCCESS = "CHECK_AUTH_SUCCESS";
export const AUTH_REFRESH_SUCCESS = "AUTH_REFRESH_SUCCESS";
export const AUTH_REFRESH_FAILURE = "AUTH_REFRESH_FAILURE";
export const RESET_PASS_SENT_SUCCESS = "RESET_PASS_SENT_SUCCESS";
export const RESET_PASS_SUCCESS = "RESET_PASS_SUCCESS";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const USER_RESOURCE_SUMMARY_SUCCESS = "USER_RESOURCE_SUMMARY_SUCCESS";

// ALL USERS
export const LOAD_ALL_USERS_SUCCESS = "LOAD_ALL_USERS_SUCCESS";
export const DELETE_ALL_USERS_SUCCESS = "DELETE_ALL_USERS_SUCCESS";

export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const SAVING_USER = "SAVING_USER";
export const REQUEST_USER_ID = "REQUEST_USER_ID";
export const UPDATE_FAVORITES_SUCCESS = "UPDATE_FAVORITES_SUCCESS";
export const UPDATE_THEME_SUCCESS = "UPDATE_THEME_SUCCESS";

export const LOAD_CUSTOMER_SUCCESS = "LOAD_CUSTOMER_SUCCESS";
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS";
export const CREATE_CUSTOMER_SUCCESS = "CREATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS";
export const SAVING_CUSTOMER = "SAVING_CUSTOMER";
export const REQUEST_CUSTOMER_ID = "REQUEST_CUSTOMER_ID";
export const REQUEST_LOCATION_ID = "REQUEST_LOCATION_ID";
export const DELETE_LOCATION_SUCCESS = "DELETE_LOCATION_SUCCESS";
export const REQUEST_NOTE_ID = "REQUEST_NOTE_ID";
export const DELETE_NOTE_SUCCESS = "DELETE_NOTE_SUCCESS";
export const LOAD_IN_PROGRESS_CUSTOMER_PROJECTS_SUCCESS =
  "LOAD_IN_PROGRESS_CUSTOMER_PROJECTS_SUCCESS";
export const CLEAR_IN_PROGRESS_CUSTOMER_PROJECTS_SUCCESS =
  "CLEAR_IN_PROGRESS_CUSTOMER_PROJECTS_SUCCESS";

export const LOAD_CONTACT_SUCCESS = "LOAD_CONTACT_SUCCESS";
export const GET_CONTACT_SUCCESS = "GET_CONTACT_SUCCESS";
export const CREATE_CONTACT_SUCCESS = "CREATE_CONTACT_SUCCESS";
export const UPDATE_CONTACT_SUCCESS = "UPDATE_CONTACT_SUCCESS";
export const DELETE_CONTACT_SUCCESS = "DELETE_CONTACT_SUCCESS";
export const SAVING_CONTACT = "SAVING_CONTACT";
export const REQUEST_CONTACT_ID = "REQUEST_CONTACT_ID";

export const LOAD_COLLECTION_SUCCESS = "LOAD_COLLECTION_SUCCESS";
export const GET_COLLECTION_SUCCESS = "GET_COLLECTION_SUCCESS";
export const CREATE_COLLECTION_SUCCESS = "CREATE_COLLECTION_SUCCESS";
export const UPDATE_COLLECTION_SUCCESS = "UPDATE_COLLECTION_SUCCESS";
export const DELETE_COLLECTION_SUCCESS = "DELETE_COLLECTION_SUCCESS";
export const SAVING_COLLECTION = "SAVING_COLLECTION";
export const REQUEST_COLLECTION_ID = "REQUEST_COLLECTION_ID";

export const LOAD_LABEL_SUCCESS = "LOAD_LABEL_SUCCESS";
export const GET_LABEL_SUCCESS = "GET_LABEL_SUCCESS";
export const CREATE_LABEL_SUCCESS = "CREATE_LABEL_SUCCESS";
export const UPDATE_LABEL_SUCCESS = "UPDATE_LABEL_SUCCESS";
export const DELETE_LABEL_SUCCESS = "DELETE_LABEL_SUCCESS";
export const SAVING_LABEL = "SAVING_LABEL";
export const REQUEST_LABEL_ID = "REQUEST_LABEL_ID";

export const LOAD_SYSTEM_SUCCESS = "LOAD_SYSTEM_SUCCESS";
export const GET_SYSTEM_SUCCESS = "GET_SYSTEM_SUCCESS";
export const CREATE_SYSTEM_SUCCESS = "CREATE_SYSTEM_SUCCESS";
export const UPDATE_SYSTEM_SUCCESS = "UPDATE_SYSTEM_SUCCESS";
export const DELETE_SYSTEM_SUCCESS = "DELETE_SYSTEM_SUCCESS";
export const SAVING_SYSTEM = "SAVING_SYSTEM";
export const REQUEST_SYSTEM_ID = "REQUEST_SYSTEM_ID";

export const LOAD_LICENSE_SUCCESS = "LOAD_LICENSE_SUCCESS";
export const GET_LICENSE_SUCCESS = "GET_LICENSE_SUCCESS";
export const CREATE_LICENSE_SUCCESS = "CREATE_LICENSE_SUCCESS";
export const UPDATE_LICENSE_SUCCESS = "UPDATE_LICENSE_SUCCESS";
export const DELETE_LICENSE_SUCCESS = "DELETE_LICENSE_SUCCESS";
export const SAVING_LICENSE = "SAVING_LICENSE";
export const REQUEST_LICENSE_ID = "REQUEST_LICENSE_ID";

export const LOAD_DEPARTMENT_SUCCESS = "LOAD_DEPARTMENT_SUCCESS";
export const GET_DEPARTMENT_SUCCESS = "GET_DEPARTMENT_SUCCESS";

export const LOAD_ROLE_SUCCESS = "LOAD_ROLE_SUCCESS";
export const GET_ROLE_SUCCESS = "GET_ROLE_SUCCESS";
export const CREATE_ROLE_SUCCESS = "CREATE_ROLE_SUCCESS";
export const UPDATE_ROLE_SUCCESS = "UPDATE_ROLE_SUCCESS";
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS";
export const SAVING_ROLE = "SAVING_ROLE";
export const REQUEST_ROLE_ID = "REQUEST_ROLE_ID";

export const LOAD_GLACCOUNT_SUCCESS = "LOAD_GLACCOUNT_SUCCESS";
export const GET_GLACCOUNT_SUCCESS = "GET_GLACCOUNT_SUCCESS";
export const CREATE_GLACCOUNT_SUCCESS = "CREATE_GLACCOUNT_SUCCESS";
export const UPDATE_GLACCOUNT_SUCCESS = "UPDATE_GLACCOUNT_SUCCESS";
export const DELETE_GLACCOUNT_SUCCESS = "DELETE_GLACCOUNT_SUCCESS";
export const SAVING_GLACCOUNT = "SAVING_GLACCOUNT";
export const REQUEST_GLACCOUNT_ID = "REQUEST_GLACCOUNT_ID";

export const LOAD_ZIP_SUCCESS = "LOAD_ZIP_SUCCESS";
export const GET_ZIP_SUCCESS = "GET_ZIP_SUCCESS";
export const CREATE_ZIP_SUCCESS = "CREATE_ZIP_SUCCESS";
export const UPDATE_ZIP_SUCCESS = "UPDATE_ZIP_SUCCESS";
export const DELETE_ZIP_SUCCESS = "DELETE_ZIP_SUCCESS";
export const SAVING_ZIP = "SAVING_ZIP";
export const REQUEST_ZIP_ID = "REQUEST_ZIP_ID";

export const LOAD_PRODCAT_SUCCESS = "LOAD_PRODCAT_SUCCESS";
export const GET_PRODCAT_SUCCESS = "GET_PRODCAT_SUCCESS";
export const CREATE_PRODCAT_SUCCESS = "CREATE_PRODCAT_SUCCESS";
export const UPDATE_PRODCAT_SUCCESS = "UPDATE_PRODCAT_SUCCESS";
export const DELETE_PRODCAT_SUCCESS = "DELETE_PRODCAT_SUCCESS";
export const SAVING_PRODCAT = "SAVING_PRODCAT";
export const REQUEST_PRODCAT_ID = "REQUEST_PRODCAT_ID";

export const LOAD_SERVICE_SUCCESS = "LOAD_SERVICE_SUCCESS";
export const GET_SERVICE_SUCCESS = "GET_SERVICE_SUCCESS";
export const CREATE_SERVICE_SUCCESS = "CREATE_SERVICE_SUCCESS";
export const UPDATE_SERVICE_SUCCESS = "UPDATE_SERVICE_SUCCESS";
export const SAVING_SERVICE = "SAVING_SERVICE";
export const REQUEST_SERVICE_ID = "REQUEST_SERVICE_ID";

export const LOAD_TASK_SUCCESS = "LOAD_TASK_SUCCESS";
export const GET_TASK_SUCCESS = "GET_TASK_SUCCESS";
export const CREATE_TASK_SUCCESS = "CREATE_TASK_SUCCESS";
export const UPDATE_TASK_SUCCESS = "UPDATE_TASK_SUCCESS";
export const SAVING_TASK = "SAVING_TASK";
export const REQUEST_TASK_ID = "REQUEST_TASK_ID";

export const LOAD_CODE_SUCCESS = "LOAD_CODE_SUCCESS";
export const GET_CODE_SUCCESS = "GET_CODE_SUCCESS";
export const CREATE_CODE_SUCCESS = "CREATE_CODE_SUCCESS";
export const UPDATE_CODE_SUCCESS = "UPDATE_CODE_SUCCESS";
export const DELETE_CODE_SUCCESS = "DELETE_CODE_SUCCESS";
export const SAVING_CODE = "SAVING_CODE";
export const REQUEST_CODE_ID = "REQUEST_CODE_ID";

export const LOAD_COMPANY_SUCCESS = "LOAD_COMPANY_SUCCESS";
export const GET_COMPANY_SUCCESS = "GET_COMPANY_SUCCESS";
export const CREATE_COMPANY_SUCCESS = "CREATE_COMPANY_SUCCESS";
export const UPDATE_COMPANY_SUCCESS = "UPDATE_COMPANY_SUCCESS";
export const DELETE_COMPANY_SUCCESS = "DELETE_COMPANY_SUCCESS";
export const SAVING_COMPANY = "SAVING_COMPANY";
export const REQUEST_COMPANY_ID = "REQUEST_COMPANY_ID";

export const LOAD_CHARGETYPE_SUCCESS = "LOAD_CHARGETYPE_SUCCESS";
export const GET_CHARGETYPE_SUCCESS = "GET_CHARGETYPE_SUCCESS";
export const CREATE_CHARGETYPE_SUCCESS = "CREATE_CHARGETYPE_SUCCESS";
export const UPDATE_CHARGETYPE_SUCCESS = "UPDATE_CHARGETYPE_SUCCESS";
export const DELETE_CHARGETYPE_SUCCESS = "DELETE_CHARGETYPE_SUCCESS";
export const SAVING_CHARGETYPE = "SAVING_CHARGETYPE";
export const REQUEST_CHARGETYPE_ID = "REQUEST_CHARGETYPE_ID";

export const LOAD_CONTRACT_SUCCESS = "LOAD_CONTRACT_SUCCESS";
export const LOAD_CONTRACT_BY_CUSTOMER_SUCCESS =
  "LOAD_CONTRACT_BY_CUSTOMER_SUCCESS";
export const GET_CONTRACT_SUCCESS = "GET_CONTRACT_SUCCESS";
export const CREATE_CONTRACT_SUCCESS = "CREATE_CONTRACT_SUCCESS";
export const UPDATE_CONTRACT_SUCCESS = "UPDATE_CONTRACT_SUCCESS";
export const DELETE_CONTRACT_SUCCESS = "DELETE_CONTRACT_SUCCESS";
export const RESET_CONTRACT_SUCCESS = "RESET_CONTRACT_SUCCESS";
export const LOADING_CONTRACT = "LOADING_CONTRACT";
export const SAVING_CONTRACT = "SAVING_CONTRACT";
export const REQUEST_CONTRACT_ID = "REQUEST_CONTRACT_ID";
export const REQUEST_CONTRACT_PO_ID = "REQUEST_CONTRACT_PO_ID";
export const REQUEST_CONTRACT_NOTE_ID = "REQUEST_CONTRACT_NOTE_ID";
export const CLEAR_CONTRACTS_SUCCESS = "CLEAR_CONTRACTS_SUCCESS";
export const LOAD_ITMS_CONTRACTS_SUCCESS = "LOAD_ITMS_CONTRACTS_SUCCESS";

export const LOAD_CALL_SUCCESS = "LOAD_CALL_SUCCESS";
export const GET_CALL_SUCCESS = "GET_CALL_SUCCESS";
export const TOGGLE_CALL = "TOGGLE_CALL";
export const DESELECT_ALL_CALLS = "DESELECT_ALL_CALLS";
export const BULK_APPROVE_SUCCESS = "BULK_APPROVE_SUCCESS";
export const BULK_COMPLETE_SUCCESS = "BULK_COMPLETE_SUCCESS";
export const CREATE_CALL_SUCCESS = "CREATE_CALL_SUCCESS";
export const GET_RECURRENCE_SUCCESS = "GET_RECURRENCE_SUCCESS";
export const GET_RECURRING_CALLS_SUCCESS = "GET_RECURRING_CALLS_SUCCESS";
export const UPDATE_CALL_SUCCESS = "UPDATE_CALL_SUCCESS";
export const DELETE_CALL_SUCCESS = "DELETE_CALL_SUCCESS";
export const RESET_CALL_SUCCESS = "RESET_CALL_SUCCESS";
export const SAVING_CALL = "SAVING_CALL";
export const LOADING_CALL = "LOADING_CALL";
export const REQUEST_PART_ID = "REQUEST_PART_ID";
export const REQUEST_CALL_SAVE = "REQUEST_CALL_SAVE";
export const REQUEST_CALL_DELETE = "REQUEST_CALL_DELETE";
export const GET_DATE_RANGE_SUCCESS = "GET_DATE_RANGE_SUCCESS";
export const GET_CALL_COUNT_SUCCESS = "GET_CALL_COUNT_SUCCESS";
export const TOGGLE_RECURRING_CALL = "TOGGLE_RECURRING_CALL";
export const GET_CALL_APPROVAL_TO_NOTIFY = "GET_CALL_APPROVAL_TO_NOTIFY";

export const SEND_TO_SQS_SUCCESS = "SEND_TO_SQS_SUCCESS";

export const LOAD_PROJECT_SUCCESS = "LOAD_PROJECT_SUCCESS";
export const GET_PROJECT_SUCCESS = "GET_PROJECT_SUCCESS";
export const CREATE_PROJECT_SUCCESS = "CREATE_PROJECT_SUCCESS";
export const UPDATE_PROJECT_SUCCESS = "UPDATE_PROJECT_SUCCESS";
export const DELETE_PROJECT_SUCCESS = "DELETE_PROJECT_SUCCESS";
export const CLONE_PROJECT_SUCCESS = "CLONE_PROJECT_SUCCESS";
export const RESET_PROJECT_SUCCESS = "RESET_PROJECT_SUCCESS";
export const SAVING_PROJECT = "SAVING_PROJECT";
export const REQUEST_PROJECT_ID = "REQUEST_PROJECT_ID";
export const REQUEST_PROJECT_TASK_ID = "REQUEST_PROJECT_TASK_ID";
export const REQUEST_PROJECT_NOTE_ID = "REQUEST_PROJECT_NOTE_ID";
export const REQUEST_PROJECT_ATTACHMENT_ID = "REQUEST_PROJECT_ATTACHMENT_ID";
export const REQUEST_PROJECT_NOTIFICATION_ID =
  "REQUEST_PROJECT_NOTIFICATION_ID";
export const GET_PROJECTS_SUCCESS = "GET_PROJECTS_SUCCESS";
export const CLEAR_PROJECTS_SUCCESS = "CLEAR_PROJECTS_SUCCESS";
export const LOAD_DPS_REPORT_SUCCESS = "LOAD_DPS_REPORT_SUCCESS";
export const LOAD_PES_REPORT_SUCCESS = "LOAD_PES_REPORT_SUCCESS";
export const LOAD_PROJECTS_WITH_SUPPORT_RESOURCES_SUCCESS =
  "LOAD_PROJECTS_WITH_SUPPORT_RESOURCES_SUCCESS";

export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const DELETE_FILE_SUCCESS = "DELETE_FILE_SUCCESS";

export const LOAD_SUPPORT_TICKETS_SUCCESS = "LOAD_SUPPORT_TICKETS_SUCCESS";
export const GET_SUPPORT_TICKET_SUCCESS = "GET_SUPPORT_TICKET_SUCCESS";
export const CLEAR_SUPPORT_TICKET_SUCCESS = "CLEAR_SUPPORT_TICKET_SUCCESS";
export const UPDATE_SUPPORT_TICKET_SUCCESS = "UPDATE_SUPPORT_TICKET_SUCCESS";
export const SAVING_SUPPORT_TICKET = "SAVING_SUPPORT_TICKET";
export const LOAD_SUPPORT_TICKETS_BOARD_SUCCESS =
  "LOAD_SUPPORT_TICKETS_BOARD_SUCCESS";

export const CREATE_EXPENSE_SUCCESS = "CREATE_EXPENSE_SUCCESS";
export const SAVING_EXPENSE = "SAVING_EXPENSE";
export const LOAD_EXPENSE_SUCCESS = "LOAD_EXPENSE_SUCCESS";
export const GET_EXPENSE_SUCCESS = "GET_EXPENSE_SUCCESS";
export const UPDATE_EXPENSE_SUCCESS = "UPDATE_EXPENSE_SUCCESS";
export const DELETE_EXPENSE_SUCCESS = "DELETE_EXPENSE_SUCCESS";
export const LOADING_EXPENSE = "LOADING_EXPENSE";
export const REQUEST_EXPENSE_ID = "REQUEST_EXPENSE_ID";
export const REQUEST_EXPENSE_RECEIPT_ID = "REQUEST_EXPENSE_RECEIPT_ID";

export const GET_BUDGET_SUCCESS = "GET_BUDGET_SUCCESS";
export const LOAD_BUDGET_SUCCESS = "LOAD_BUDGET_SUCCESS";
export const ADD_BUDGET_SUCCESS = "ADD_BUDGET_SUCCESS";

export const CREATE_PTOREQUEST_SUCCESS = "CREATE_PTOREQUEST_SUCCESS";
export const SAVING_PTOREQUEST = "SAVING_PTOREQUEST";
export const LOAD_PTOREQUEST_SUCCESS = "LOAD_PTOREQUEST_SUCCESS";
export const GET_PTOREQUEST_SUCCESS = "GET_PTOREQUEST_SUCCESS";
export const UPDATE_PTOREQUEST_SUCCESS = "UPDATE_PTOREQUEST_SUCCESS";
export const DELETE_PTOREQUEST_SUCCESS = "DELETE_PTOREQUEST_SUCCESS";
export const LOADING_PTOREQUEST = "LOADING_PTOREQUEST";
export const REQUEST_PTOREQUEST_ID = "REQUEST_PTOREQUEST_ID";
export const TOGGLE_LOADER = "TOGGLE_LOADER";
export const LOAD_PTOSUMMARY_SUCCESS = "LOAD_PTOSUMMARY_SUCCESS";

export const LOAD_CONTRACT_TIER_SUCCESS = "LOAD_CONTRACT_TIER_SUCCESS";
export const GET_CONTRACT_TIER_SUCCESS = "GET_CONTRACT_TIER_SUCCESS";
export const CREATE_CONTRACT_TIER_SUCCESS = "CREATE_CONTRACT_TIER_SUCCESS";
export const UPDATE_CONTRACT_TIER_SUCCESS = "UPDATE_CONTRACT_TIER_SUCCESS";
export const SAVING_CONTRACT_TIER = "SAVING_CONTRACT_TIER";
export const REQUEST_CONTRACT_TIER_ID = "REQUEST_CONTRACT_TIER_ID";
export const GET_RESOURCE_SUMMARY_REPORT_SUCCESS =
  "GET_RESOURCE_SUMMARY_REPORT_SUCCESS";

// REPORTS
export const GET_CUSTOMER_PROJECT_STATUS_REPORT_SUCCESS =
  "GET_CUSTOMER_PROJECT_STATUS_REPORT_SUCCESS";
export const GET_CALL_DETAIL_REPORT_SUCCESS = "GET_CALL_DETAIL_REPORT_SUCCESS";
export const GET_MONTHLY_REVENUE_ANALYSIS_REPORT_SUCCESS =
  "GET_MONTHLY_REVENUE_ANALYSIS_REPORT_SUCCESS";
export const CLEAN_MRA_REPORT = "CLEAN_MRA_REPORT";

export const LOAD_DEPARTMENT_CATEGORY_SUCCESS =
  "LOAD_DEPARTMENT_CATEGORY_SUCCESS";
export const GET_DEPARTMENT_CATEGORY_SUCCESS =
  "GET_DEPARTMENT_CATEGORY_SUCCESS";
export const SAVING_DEPARTMENT_CATEGORY = "SAVING_DEPARTMENT_CATEGORY";
export const SAVING_DEPARTMENT = "SAVING_DEPARTMENT";
export const CREATE_DEPARTMENT_CATEGORY_SUCCESS =
  "CREATE_DEPARTMENT_CATEGORY_SUCCESS";
export const UPDATE_DEPARTMENT_CATEGORY_SUCCESS =
  "UPDATE_DEPARTMENT_CATEGORY_SUCCESS";
export const UPDATE_DEPARTMENT_SUCCESS = "UPDATE_DEPARTMENT_SUCCESS";
export const CLEAR_RESOURCE_SUMMARY = "CLEAR_RESOURCE_SUMMARY";
export const CLEAR_REPORT = "CLEAR_REPORT";
export const GET_DAILY_CALL_COMPLETION_REPORT_SUCCESS =
  "GET_DAILY_CALL_COMPLETION_REPORT_SUCCESS";
export const GET_OPEN_SUPPORT_TICKETS_REPORT_SUCCESS =
  "GET_OPEN_SUPPORT_TICKETS_REPORT_SUCCESS";
export const GET_PROJECT_SERVICE_ANALYSIS_REPORT_SUCCESS =
  "GET_PROJECT_SERVICE_ANALYSIS_REPORT_SUCCESS";
export const CLEAR_PROJECT_SERVICE_ANALYSIS_REPORT =
  "CLEAR_PROJECT_SERVICE_ANALYSIS_REPORT";

// EXPORTING
export const EXPORT_SUCCESS = "EXPORT_SUCCESS";
export const EXPORTING = "EXPORTING";
export const CLEAR_EXPORTED = "CLEAR_EXPORTED";

// BC INVOICES

export const CREATE_BC_INVOICE_SUCCESS = "CREATE_BC_INVOICE_SUCCESS";
export const CREATE_BC_INVOICE_LINE_SUCCESS = "CREATE_BC_INVOICE_LINE_SUCCESS";

// Tax Codes
export const LOAD_TAX_CODES_SUCCESS = "LOAD_TAX_CODES_SUCCESS";
